// jQuery=internal
import * as $ from 'jquery';

// Polyfills
import 'bootstrap/polyfills';

// Embeds
import 'by-category/scs.header';
import 'by-category/scs.sitesearch';

// Only now add the scsHeaderJQuery, otherwise the functionality set is not complete.
declare global {
	interface Window {
		scsHeaderJQuery : JQueryStatic;
	}
}

// Use string concatenation to prevent webpack.ProvidePlugin from re-writing the access to window.scsHeaderJQuery.
// tslint:disable-next-line:no-string-literal
(window as any)['scsHeader' + 'JQuery'] = $.noConflict(true);



// WEBPACK FOOTER //
// typescript://../header/ui/src/main/content/jcr_root/etc/designs/header/clientlibs/aggregated.ts